import {
    BanknotesIcon,
    BriefcaseIcon,
    ClockIcon,
    DocumentTextIcon,
    FolderIcon,
} from '@heroicons/react/24/outline';
import { Card, Group, rem, SimpleGrid, Stack, Text, ThemeIcon } from '@mantine/core';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface DictionaryTile {
    id: string;
    title: string;
    description: string;
    icon: React.ForwardRefExoticComponent<React.SVGProps<SVGSVGElement>>;
    route: string;
    color: string;
}

const DICTIONARY_TILES: DictionaryTile[] = [
    {
        id: 'cost-centers',
        title: 'Cost Centers',
        description: 'Manage cost center codes and display names imported from Enova',
        icon: BanknotesIcon,
        route: '/operations/employee-hub/dictionaries/cost-centers',
        color: 'blue',
    },
    {
        id: 'projects',
        title: 'Projects',
        description: 'Manage project codes used for employee allocations',
        icon: FolderIcon,
        route: '/operations/employee-hub/dictionaries/projects',
        color: 'green',
    },
    {
        id: 'work-schedules',
        title: 'Work Schedules',
        description: 'Manage work schedule codes and display names',
        icon: ClockIcon,
        route: '/operations/employee-hub/dictionaries/work-schedules',
        color: 'orange',
    },
    {
        id: 'positions',
        title: 'Positions',
        description: 'Manage employee position codes and display names',
        icon: BriefcaseIcon,
        route: '/operations/employee-hub/dictionaries/positions',
        color: 'purple',
    },
    {
        id: 'contract-types',
        title: 'Contract Types',
        description: 'Manage employment contract type codes and display names',
        icon: DocumentTextIcon,
        route: '/operations/employee-hub/dictionaries/contract-types',
        color: 'teal',
    },
];

export const EmployeeDictionaryTiles: React.FC = () => {
    const navigate = useNavigate();

    return (
        <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="lg">
            {DICTIONARY_TILES.map((tile) => (
                <Card
                    key={tile.id}
                    p="xl"
                    radius="md"
                    withBorder
                    shadow="sm"
                    style={{ cursor: 'pointer' }}
                    onClick={() => navigate(tile.route)}
                >
                    <Stack gap="md">
                        <Group justify="space-between">
                            <ThemeIcon size={48} radius="md" variant="light" color={tile.color}>
                                <tile.icon style={{ width: rem(24), height: rem(24) }} />
                            </ThemeIcon>
                        </Group>

                        <div>
                            <Text fw={600} size="lg" mb="xs">
                                {tile.title}
                            </Text>
                            <Text size="sm" c="dimmed">
                                {tile.description}
                            </Text>
                        </div>
                    </Stack>
                </Card>
            ))}
        </SimpleGrid>
    );
};
